<template>
  <div class="results__container the-results">
    <div class="result__head-container">
      <div class="result__background-one"/>
      <div class="result__background-two"/>
      <div class="unm__container result__head">
        <div
          v-if="!quizEnded"
          class="result__head-progress">
          <h1 class="heading-main">
            <strong>You're almost there.</strong>
          </h1>
          <!-- eslint-disable-next-line max-len -->
          <p class="paragraph paragraph-splash">Complete the quiz to review your answers and see if you're Lobo ready!</p>
        </div>
        <div v-else>
          <h1 class="heading-main">
            <strong v-if="name">{{ name }},</strong>
            <strong v-else>Are you ready?</strong>
          </h1>
          <p class="paragraph paragraph-splash">Join the pack</p>
        </div>
        <div class="result__toggle-container">
          <div @change="updateTitle">
            <label class="results__favorites-cta cta-small">
              <input
                v-model="set"
                type="radio"
                value="all"
                class="results__favorites-input radio-input"
              >
              <span class="results__favorites-cta_background"/>
              <span class="results__favorites-cta_copy">All Results</span>
            </label>
            <label class="results__favorites-cta cta-small">
              <input
                v-model="set"
                type="radio"
                value="saved"
                class="results__favorites-input radio-input"
              >
              <span class="results__favorites-cta_background"/>
              <span class="results__favorites-cta_copy">Saved Tips</span>
            </label>
          </div>
        </div>
        <svg class="glyph__breaker">
          <use xlink:href="/images/graphics/menu-anchor-glyph.svg#menu-anchor-glyph" />
        </svg>
      </div>
    </div>
    <div class="results__results-container">
      <div class="result__image unm__image"/>
      <div class="unm__container">
        <transition-group
          v-if="questionSet.length"
          tag="ul"
          class="results__list"
        >
          <li
            v-for="question in questionSet"
            :key="question.prompt"
            class="results__list-item"
          >
            <div
              v-if="question.answer"
              class="results-meta__answered">
              <div class="results-meta__counter">
                <span
                  class="number results-meta__number"
                  v-text="'0' + (questions.indexOf(question) + 1)"
                />
                <span class="label label-results results-meta__callout">Did you know</span>
                <button
                  :class="{favorited: question.saved}"
                  class="favorite__button results__favorite-button"
                  @click="toggleQuestionSaved(question)"
                >
                  <div
                    aria-hidden="true"
                    class="favorite-icon__container">
                    <svg class="favorite-outline-icon">
                      <!-- eslint-disable-next-line max-len -->
                      <use xlink:href="/images/icons/favorite-outline-icon.svg#favorite-outline-icon" />
                    </svg>
                    <svg class="favorite-filled-icon">
                      <!-- eslint-disable-next-line max-len -->
                      <use xlink:href="/images/icons/favorite-filled-icon.svg#favorite-filled-icon" />
                    </svg>
                  </div>
                </button>
              </div>
              <div class="results-meta__image">
                <div class="result-meta__image-wrapper">
                  <img
                    :src="question.answer.response.image"
                    class="results__list-image">
                </div>
              </div>
              <div class="results-meta__response">
                <h2
                  class="result__list-label label label-response"
                  v-text="question.answer.text"/>
                <p
                  class="paragraph paragraph-quiz"
                  v-text="question.answer.response.text"/>
                <a
                  :href="question.answer.response.link"
                  class="cta cta-small transparent-cta results-cta"
                  target="_blank"
                  v-text="question.answer.response.cta"/>
              </div>
            </div>
            <div
              v-if="!question.answer"
              class="results-meta__unanswered">
              <div class="results-meta__counter-locked">
                <span
                  class="number results-meta__number"
                  v-text="'0' + (questions.indexOf(question) + 1)"
                />
                <span class="label label-results results-meta__callout">Did you know</span>
              </div>
              <div class="results-meta__locked">
                <svg class="lock-icon">
                  <use xlink:href="/images/icons/lock-icon.svg#lock-icon" />
                </svg>
              </div>
            </div>
          </li>
        </transition-group>
        <div
          v-else
          class="no-favorites"
        >
          <p class="paragraph paragraph-quiz">You have no saved questions.</p>
        </div>
      </div>
    </div>
    <div class="progress__cta-container">
      <p class="paragraph paragraph-splash progress__copy">You're almost to Lobo Ready</p>
      <button
        class="cta-small continue-cta progress__cta"
        @click="toggleMenu"
      >Continue</button>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations } from 'vuex';

  export default {
    name: 'TheResults',
    data() {
      return {
        set: 'all',
      };
    },
    computed: {
      questionSet() {
        const { questions } = this;

        return {
          all: questions,
          saved: questions.filter(({ saved }) => saved),
        }[this.set];
      },
      ...mapState([
        'name',
        'stage',
        'questions',
        'quizEnded',
        'willHideTutorial',
      ]),
      ...mapGetters(['activeQuestionIndexString']),
    },
    activated() {
      const { quizEnded } = this;

      if (quizEnded) {
        this.set = 'all';
      }

      if (this.willHideTutorial) {
        this.set = 'saved';
        this.setWillHideTutorial(false);
      }

      this.updateTitle();
      this.setHud({
        top: quizEnded ? 'Complete' : 'Progress',
        bottom: `0${this.activeQuestionIndexString}/0${this.questions.length}`,
      });
    },
    methods: {
      updateTitle() {
        if (this.quizEnded) {
          this.setTitle({
            all: 'Your Results',
            saved: 'Your Saved Tips',
          }[this.set]);
        }
      },
      ...mapMutations([
        'setHud',
        'setTitle',
        'toggleMenu',
        'toggleQuestionSaved',
        'setWillHideTutorial',
      ]),
    },
  };
</script>

<style lang="scss">

$progress-disclosure-height-small: 150px;
$progress-disclosure-height-large: 100px;

.result__head-container {
  position: relative;
  padding: 145px 0 45px;
  background-image: url("/images/graphics/red-texture.png");
  background-size: 50px;
  background-repeat: repeat;

  @include breakpoint(large) {
    padding: 225px 0 80px;
  }
}

.result__head {
  display: block;
  text-align: center;
}

.result__background-one,
.result__background-two {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.result__background-one {
    background-image: url("/images/graphics/agave.png");
    background-size: 250px;
    background-position: left bottom;
    background-repeat: no-repeat;
    z-index: 1;
}

.result__background-two {
    background-image: url("/images/backgrounds/background-glyph-02.svg");
    background-size: 70%;
    background-position: right top;
    background-repeat: no-repeat;
    z-index: 1;
}

.result__toggle-container {
  margin: 50px 0;

  @include breakpoint(large) {
    margin: 40px 0;
  }
}

.results__container {
  @include z-index(results);
  position: absolute;
  width: 100%;
  padding-bottom: $progress-disclosure-height-small;

  @include breakpoint(large) {
    padding-bottom: $progress-disclosure-height-large;
  }
}

.results__results-container {
  position: relative;
  background-image: url("/images/graphics/white-texture.png");
  background-size: 50px;
  background-repeat: repeat;
}

.results__list {
  width: 100%;
}

.results__list-item {
  padding-top: 30px;
  padding-bottom: 30px;
  border-bottom: 2px solid rgb(225, 225, 225);
  transition-duration: $transition-duration;

  @include breakpoint(large) {
    padding-top: 60px;
    padding-bottom: 60px;
  }
}

.results-meta__answered,
.results-meta__unanswered {
  @include flex-grid-row;
}

.results-meta__unanswered {
  display: flex;
  align-items: center;
}

.results-cta {
  padding: 10px 15px;

  @include breakpoint(medium) {
    width: auto;
  }
}

.results-meta__counter {
  @include flex-grid-column(12);
  display: flex;
  align-items: center;

  @include breakpoint(large) {
    @include flex-grid-size(2);
    display: block;
  }
}

.results-meta__counter-locked {
  @include flex-grid-column(9);

  @include breakpoint(large) {
    @include flex-grid-size(2);
  }
}

.results-meta__image {
  @include flex-grid-column(12);
  margin-top: 20px;
  height: 145px;

  @include breakpoint(medium) {
    height: 250px;
  }

  @include breakpoint(large) {
    @include flex-grid-size(4);
    margin-top: 0;
    height: 235px;
  }
}

.results-meta__response {
  @include flex-grid-column(12);

  @include breakpoint(large) {
    @include flex-grid-size(6);
    padding-right: 50% - 41.66667%;
  }
}

.result-meta__image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.result__list-label {
  margin-top: 20px;
  margin-bottom: 20px;

  @include breakpoint(large) {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.results__list-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.results-meta__number {
  display: inline-block;
  margin-right: 10px;

  @include breakpoint(large) {
    display: block;
    margin-right: 0;
    text-align: center;
  }
}

.results-meta__callout {
  width: 100%;

  @include breakpoint(large) {
    display: block;
    max-width: 90px;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 30px;
    text-align: center;
  }
}

.results-meta__locked {
  @include flex-grid-column(3);
  display: flex;
  justify-content: flex-end;

  @include breakpoint(large) {
    @include flex-grid-size(10);
    align-items: center;
    justify-content: center;
  }
}

.lock-icon {
  width: 20px;
  height: 30px;
  fill: $turquoise;

  @include breakpoint(large) {
    width: 32px;
    height: 47px;
  }
}

.results__favorite-button {

  @include breakpoint(large) {
    margin: 0 auto;
  }
}

.progress__cta-container {
  @include flex-grid-column(12);
  @include z-index(progress-disclosure);
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: $progress-disclosure-height-small;
  background-color: $turquoise;
  flex-direction: column;

  @include breakpoint(large) {
    flex-direction: row;
    height: $progress-disclosure-height-large;
  }
}

.result__head-progress {
  @include flex-grid-row(12);
  @include flex-grid-column(12);
  flex-direction: column;
}

.progress__copy {
  text-align: center;

  @include breakpoint(large) {
    text-align: left;
  }
}

.progress__cta {
  margin-top: 20px;

  @include breakpoint(large) {
    margin-top: 0;
    margin-left: 20px;
  }
}

.header__hud-top,
.header__hud-bottom {
  display: block;
  text-align: center;
}

.the-results {
  &.v-enter,
  &.v-leave-to {
    opacity: 0;
  }

  &.v-enter-active,
  &.v-leave-active {
    transition-duration: $stage-transition-duration;
    transition-property: opacity;
    transition-timing-function: $transition-timing-function;
  }
}

.no-favorites {
  @include flex-grid-column(12);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
}

.results__favorites-cta {
  position: relative;
  display: inline-block;
  padding: 10px 30px;
  cursor: pointer;
  transition:
    background-color $cta-transition-duration $cta-transition-timing-function,
    color $cta-transition-duration $cta-transition-timing-function;

  &:hover {
    .results__favorites-input + .results__favorites-cta_background {
        background-color: #7b031b;
    }

    .results__favorites-input:checked + .results__favorites-cta_background {
        background-color: rgb(25, 90, 93);
    }
  }
}

.results__favorites-cta {
  border-radius: $radio-border-radius 0 0 $radio-border-radius;
  overflow: hidden;
}

.results__favorites-cta + .results__favorites-cta {
  border-radius: 0 $radio-border-radius $radio-border-radius 0;
}


.results__favorites-cta_background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
}

.results__favorites-cta_copy {
  position: relative;
  color: $white;
  z-index: 1;
  transition-duration: $cta-transition-duration;
  transition-property: opacity;
  transition-timing-function: $transition-timing-function;
}

.results__favorites-input + .results__favorites-cta_background {
  background-color: rgb(147, 12, 43);
}

.results__favorites-input ~ .results__favorites-cta_copy {
  color: #f6a0a0;
}

.results__favorites-input:checked ~ .results__favorites-cta_copy {
  color: $white;
}

.results__favorites-input:checked + .results__favorites-cta_background {
  background-color: $turquoise;
}

</style>



// WEBPACK FOOTER //
// src/components/TheResults.vue